import { render, staticRenderFns } from "./WithdrawRecord.vue?vue&type=template&id=177c2f70&scoped=true"
import script from "./WithdrawRecord.vue?vue&type=script&lang=js"
export * from "./WithdrawRecord.vue?vue&type=script&lang=js"
import style0 from "./WithdrawRecord.vue?vue&type=style&index=0&id=177c2f70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177c2f70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('177c2f70')) {
      api.createRecord('177c2f70', component.options)
    } else {
      api.reload('177c2f70', component.options)
    }
    module.hot.accept("./WithdrawRecord.vue?vue&type=template&id=177c2f70&scoped=true", function () {
      api.rerender('177c2f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/financials-agent/components/Balance/WithdrawRecord.vue"
export default component.exports